
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("1HKGQ", function(module, exports) {

$parcel$export(module.exports, "EPCheck", () => $54a00b609e80d9e5$export$662f3e7de71f1a7);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $lpwtK = parcelRequire("lpwtK");

var $2NMNM = parcelRequire("2NMNM");

var $5XoJl = parcelRequire("5XoJl");

var $hJMp3 = parcelRequire("hJMp3");
const $54a00b609e80d9e5$export$662f3e7de71f1a7 = ({ onComplete: onComplete, children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { data: project } = (0, $lpwtK.useProject)();
    const projectType = (0, $2vSU6.toProjectType)(project?.type);
    const [hasMessageStarted, setHasMessageStarted] = (0, $5uXOq.useState)(false);
    const [hasCheckedEpMessage, setHasCheckedEpMessage] = (0, $5uXOq.useState)(false);
    const { start: checkEPMessage } = (0, $hJMp3.useCoordinationClient)(projectType);
    (0, $5uXOq.useEffect)(()=>{
        // reset checks when we switch projects
        setHasCheckedEpMessage(false);
        setHasMessageStarted(false);
    }, [
        projectType
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (hasCheckedEpMessage || projectType === undefined) return;
        (async ()=>{
            setHasCheckedEpMessage(true);
            const hasStarted = await checkEPMessage();
            (0, $5XoJl.fireTrackAnalyticsEvent)(createAnalyticsEvent, 'engagementPlatformMessage checked', {
                projectType: projectType,
                hasCheckedEpMessage: hasCheckedEpMessage,
                hasEPStarted: hasStarted
            });
            setHasMessageStarted(hasStarted);
            hasStarted && onComplete();
        })();
    }, [
        createAnalyticsEvent,
        checkEPMessage,
        hasCheckedEpMessage,
        onComplete,
        projectType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, hasMessageStarted && children);
};

});
parcelRegister("5XoJl", function(module, exports) {

$parcel$export(module.exports, "fireButtonAnalytics", () => $9f028da2a090e272$export$ac665b9f9662b94a);
$parcel$export(module.exports, "fireErrorAnalytics", () => $9f028da2a090e272$export$a27c21aa3ed8f0f1);
$parcel$export(module.exports, "fireTrackAnalyticsEvent", () => $9f028da2a090e272$export$d5afa3e4b289a23);

var $8zOmE = parcelRequire("8zOmE");

const $9f028da2a090e272$export$ac665b9f9662b94a = (createAnalyticsEvent, actionSubjectId, attributes)=>{
    (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
        actionSubject: 'button',
        action: 'clicked',
        source: 'jira'
    }), actionSubjectId, {
        ...attributes
    });
};
const $9f028da2a090e272$export$a27c21aa3ed8f0f1 = (createAnalyticsEvent, reason)=>{
    (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({
        source: 'jira'
    }), 'experiment error', {
        reason: reason,
        experimentKey: (0, $ae99efb22fc8caeb$export$a9066c48870ddcc5)
    });
};
const $9f028da2a090e272$export$d5afa3e4b289a23 = (createAnalyticsEvent, actionSubjectId, attributes)=>{
    (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({
        source: 'jira'
    }), actionSubjectId, {
        experimentKey: (0, $ae99efb22fc8caeb$export$a9066c48870ddcc5),
        ...attributes
    });
};

});
const $ae99efb22fc8caeb$export$a9066c48870ddcc5 = 'cross-flow-defer-edition-communication';


parcelRegister("hJMp3", function(module, exports) {

$parcel$export(module.exports, "useCoordinationClient", () => $46416ab3d0500c73$export$ddc368dc94a41e62);

var $5uXOq = parcelRequire("5uXOq");

var $eGLgs = parcelRequire("eGLgs");

var $14XJw = parcelRequire("14XJw");

var $koeKL = parcelRequire("koeKL");

var $gXMG7 = parcelRequire("gXMG7");
const $46416ab3d0500c73$export$ddc368dc94a41e62 = (projectType)=>{
    const epMessageId = (0, $gXMG7.useDeferEpMessageKey)(projectType);
    const cloudId = (0, $koeKL.useCloudId)();
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const coordinationClient = (0, $5uXOq.useMemo)(()=>new (0, $eGLgs.CoordinationClient)(cloudId, '/gateway/api', false, orgId, 'engagement'), [
        cloudId,
        orgId
    ]);
    const start = (0, $5uXOq.useCallback)(async ()=>{
        if (!epMessageId) return false;
        return coordinationClient.start(epMessageId);
    }, [
        epMessageId,
        coordinationClient
    ]);
    const stop = (0, $5uXOq.useCallback)(()=>{
        if (!epMessageId) return false;
        return coordinationClient.stop(epMessageId);
    }, [
        epMessageId,
        coordinationClient
    ]);
    return {
        start: start,
        stop: stop
    };
};

});
parcelRegister("gXMG7", function(module, exports) {

$parcel$export(module.exports, "useDeferEpMessageKey", () => $075dcc142f8ca680$export$46bdb0804933a5fd);

var $2vSU6 = parcelRequire("2vSU6");

var $2tT7R = parcelRequire("2tT7R");

const $075dcc142f8ca680$export$46bdb0804933a5fd = (projectType)=>{
    const environment = (0, $2tT7R.useEnvironment)();
    const isProdEnv = environment === 'prod';
    switch(projectType){
        case 0, $2vSU6.CORE_PROJECT:
            return isProdEnv ? (0, $ac4f2a72f86d65c9$export$f36bed87d45a98de) : (0, $ac4f2a72f86d65c9$export$a0f8b0f73985911a);
        case 0, $2vSU6.SOFTWARE_PROJECT:
            return isProdEnv ? (0, $ac4f2a72f86d65c9$export$475f4ac16b63ff71) : (0, $ac4f2a72f86d65c9$export$3fc71bcf4d7deeea);
        case 0, $2vSU6.PRODUCT_DISCOVERY_PROJECT:
            return isProdEnv ? (0, $ac4f2a72f86d65c9$export$58003a8be3bebb14) : (0, $ac4f2a72f86d65c9$export$4b374f476a475bef);
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return isProdEnv ? (0, $ac4f2a72f86d65c9$export$b302977ba64b0fa) : (0, $ac4f2a72f86d65c9$export$bfaa609ebcf522b6);
        default:
            return undefined;
    }
};

});
const $ac4f2a72f86d65c9$export$b8b9d90f9e5bd72b = 'DeferEditionModal';
const $ac4f2a72f86d65c9$export$d57b6b390e78d90f = 'transmuters-growth';
const $ac4f2a72f86d65c9$export$4b374f476a475bef = 'stg-defer-edition-crossflow-jpd';
const $ac4f2a72f86d65c9$export$3fc71bcf4d7deeea = 'stg-defer-edition-crossflow-jsw';
const $ac4f2a72f86d65c9$export$a0f8b0f73985911a = 'stg-defer-edition-crossflow-jwm';
const $ac4f2a72f86d65c9$export$bfaa609ebcf522b6 = 'stg-defer-edition-crossflow-jsm';
const $ac4f2a72f86d65c9$export$58003a8be3bebb14 = 'defer-edition-crossflow-jpd';
const $ac4f2a72f86d65c9$export$475f4ac16b63ff71 = 'defer-edition-crossflow-jsw';
const $ac4f2a72f86d65c9$export$f36bed87d45a98de = 'defer-edition-crossflow-jwm';
const $ac4f2a72f86d65c9$export$b302977ba64b0fa = 'defer-edition-crossflow-jsm';





//# sourceMappingURL=async-jira-defer-edition-ep-check.8707e062.js.map
